import React from 'react';
import { useRecoilValue } from 'recoil';
import { totalPlayerCountAtom } from '../../data/atoms';

export default function PlayerCount(props) {
    const count = useRecoilValue(totalPlayerCountAtom)

    return count;
}